import React, { createElement } from 'react'

// Node Modules
import { domToReact, DomElement } from 'html-react-parser'

// Components
import Collapsible from 'components/xis/Collapsible'

// Util
import { hasAttrib, hasClass } from 'util/xis-parser/conditions'

export default (node:DomElement, params:any, options:any) => {

  let childrenEl = node.children || []
  const title = childrenEl.filter(c => hasAttrib(c, 'data-collapse-trigger'))
  const content = childrenEl.filter(c => hasAttrib(c, 'data-collapse-content') || hasClass(c, 'xisCas-syntax-punctuation'))
  const ariaLabel = title[0] && title[0].attribs ? title[0].attribs['data-collapse-trigger'] : null

  const titleEl = title ? domToReact(title, options) : <React.Fragment />
  const contentEl = content ? domToReact(content, options) : <React.Fragment />

  // Hotfix 2.18.1: hide Expand/collapse buttons if missing full hand-shake attributes.
  let condition = childrenEl.filter(c => hasAttrib(c, 'data-collapse-content') || hasClass(c, 'xisCas-syntax-punctuation')).length !== 0

  if (condition) {
    return createElement(
      Collapsible as React.FunctionComponent, 
      { 
        title: titleEl,
        content: contentEl,
        sectionLabel: ariaLabel
      } as any
    )
  }
   

}